import { useEffect, useState } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import ProfitLossChart from "../component/ProfitLossChart";
import CommonTable from "../component/CommonTable";
import axios from "axios";
import { BASE_URL } from "../api";
import MessageToster from "../component/MessageToster";
import Loader from "../component/Loader";
import { getApiHeaders } from "../utils/helpers";
import { useHandleError } from "../hooks/useHandleError";
import { useNavigate } from "react-router-dom";

export default function LiveAccountDashboard() {

  const navigate = useNavigate();
  const handleError = useHandleError();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(sessionStorage.getItem("live_account_no") || "");

  useEffect(() => {
    const fetchAccounts = async () => {
      const mid = sessionStorage.getItem("mid");
      if (!mid) return;

      const bodyData = { mid: Number(mid), mode: "" };

      try {
        const res = await axios.post(`${BASE_URL}/MT5M/real_accounts_number_list`, bodyData, { headers: getApiHeaders() });

        if (res.data.code === 200) {
          setAccounts(res.data.data || []);
          if (!selectedAccount && res.data.data.length > 0) {
            const firstAcc = res.data.data[0];
            setSelectedAccount(firstAcc);
            sessionStorage.setItem("live_account_no", firstAcc);
          }
        } else {
          MessageToster("error", res.data.message || "Unable to fetch accounts");
        }
      } catch (err) {
        handleError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAccounts();
  }, []);

  useEffect(() => {
    const fetchDashboardData = async () => {
      if (!selectedAccount) return;

      const bodyData = {
        mode: "",
        user_login: Number(selectedAccount),
      };

      setLoading(true);
      try {
        const res = await axios.post(`${BASE_URL}/MT5M/user_dashboard_data_by_id`, bodyData, { headers: getApiHeaders() });

        if (res.data.code === 200) {
          setDashboardData(res.data.message);
        } else {
          MessageToster("error", res.data.message || "Something went wrong");
        }
      } catch (error) {
        handleError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [selectedAccount]);

  const handleAccountChange = (e) => {
    const accNo = e.target.value;
    setSelectedAccount(accNo);
  };

  return (
    <>
      <div id="layout-wrapper">
        {loading &&
          <Loader />
        }
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="card overflow-hidden">
                    <div className="card-body bg-warning-subtle d-flex justify-content-between align-items-center">
                      <div className="col-12">
                        <div className="row align-items-center g-4">
                          <div className="col-md-6">
                            <div>
                              <p className="mb-0">
                                Change Password: A strong password helps you to keep
                                information safe.
                              </p>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="d-flex justify-content-end gap-3">
                              <button
                                type="button"
                                className="btn btn-outline-warning waves-effect waves-light"
                                onClick={() => navigate(`/masterpassword?account=${selectedAccount}&type=live`)}
                              >
                                Change Trading Password
                              </button>
                              <button
                                className="btn btn-warning waves-effect waves-light"
                                type="button"
                                onClick={() => navigate(`/investorpassword?account=${selectedAccount}&type=live`)}
                              >
                                Change Investor Password
                              </button>
                              {/* <button
                                type="button"
                                className="btn btn-outline-warning waves-effect waves-light"
                              >
                                Change Trading Password
                              </button> */}
                              {/* <button
                                type="button"
                                className="btn btn-warning waves-effect waves-light"
                              >
                                Change investor Password
                              </button> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h2 className="mb-sm-0">
                      Live Account Dashboard
                    </h2>
                    <div className="d-flex gap-2">
                      <p className="text-nowrap mt-1 mb-0">Select Live Account</p>
                      <select className="form-select" value={selectedAccount} onChange={handleAccountChange}>
                        {accounts.length > 0 ? (
                          accounts.map(acc => <option key={acc} value={acc}>{acc}</option>)
                        ) : (
                          <option disabled>No accounts available</option>
                        )}
                      </select>

                      {/* <select
                        className="form-select form-select-sm pe-5"
                        value={selectedAccount}
                        onChange={handleAccountChange}
                      >
                        {accounts.map((acc) => (
                          <option key={acc} value={acc}>
                            {acc}
                          </option>
                        ))}
                      </select> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* end page title */}
              <div className="row">
                <div className="col-xl-3 col-lg-6 col-sm-6">
                  <div className="card card-animate overflow-hidden upcoming-box bg-white-subtle">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="fw-medium text-muted mb-0">Total Balance</p>
                          <h2 className="mt-4 ff-secondary cfs-22 fw-semibold"><span className="counter-value" data-target="28.05">{dashboardData?.Balance || 0}</span></h2>
                        </div>
                        <div>
                          <div className="avatar-sm upcoming-icon">
                            <span className="avatar-title dash_icon bg-info-subtle rounded fs-2">
                              <i className="bx bx-wallet font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="card mini-stats-wid">
                    <div className="card-body bg-danger-subtle">
                      <div className="row pt-3">
                        <div className="col-7">
                          <div>
                            <h5 className="fw-bold">100.00</h5>
                            <p className="text-muted text-truncate mb-0">
                              Total Balance
                            </p>
                          </div>
                        </div>
                        <div className="col-5">
                          <div className="flex-shrink-0 align-self-center pb-3">
                            <div className="mini-stat-icon avatar-sm rounded-circle bg-primary ms-auto">
                              <span className="avatar-title bg-danger">
                                <i className="bx bx-credit-card font-size-24" />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="col-xl-3 col-lg-6 col-sm-6">
                  <div className="card card-animate overflow-hidden upcoming-box bg-white-subtle">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        {/* coming soon... */}
                        <div>
                          <p className="fw-medium text-muted mb-0">Currency</p>
                          <h2 className="mt-4 ff-secondary cfs-22 fw-semibold"><span className="counter-value" data-target="28.05">USD</span></h2>
                        </div>
                        <div>
                          <div className="avatar-sm upcoming-icon">
                            <span className="avatar-title dash_icon bg-info-subtle rounded fs-2">
                              <i className="bx bx-dollar-circle  font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="card mini-stats-wid">
                    <div className="card-body bg-primary-subtle">
                      <div className="row pt-3">
                        <div className="col-7">
                          <div>
                            <h5 className="fw-bold">USD</h5>
                            <p className="text-muted text-truncate mb-0">
                              Currency
                            </p>
                          </div>
                        </div>
                        <div className="col-5">
                          <div className="flex-shrink-0 align-self-center pb-3">
                            <div className="mini-stat-icon avatar-sm rounded-circle bg-primary ms-auto">
                              <span className="avatar-title bg-primary">
                                <i className="bx bx-dollar-circle  font-size-24" />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="col-xl-3 col-lg-6 col-sm-6">
                  <div className="card card-animate overflow-hidden upcoming-box bg-white-subtle">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="fw-medium text-muted mb-0">Platform</p>
                          <h2 className="mt-4 ff-secondary cfs-22 fw-semibold"><span className="counter-value" data-target="28.05">MT5</span></h2>
                        </div>
                        <div>
                          <div className="avatar-sm upcoming-icon">
                            <span className="avatar-title dash_icon bg-info-subtle rounded fs-2">
                              <i className="bx bx-layer font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="card mini-stats-wid">
                    <div className="card-body bg-info-subtle">
                      <div className="row pt-3">
                        <div className="col-7">
                          <div>
                            <h5 className="fw-bold">MTS</h5>
                            <p className="text-muted text-truncate mb-0">
                              Platform
                            </p>
                          </div>
                        </div>
                        <div className="col-5">
                          <div className="flex-shrink-0 align-self-center pb-3">
                            <div className="mini-stat-icon avatar-sm rounded-circle bg-primary ms-auto">
                              <span className="avatar-title bg-info">
                                <i className="bx bx-desktop font-size-24" />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="col-xl-3 col-lg-6 col-sm-6">
                  <div className="card card-animate overflow-hidden upcoming-box bg-white-subtle">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="fw-medium text-muted mb-0">Leverage</p>
                          <h2 className="mt-4 ff-secondary cfs-22 fw-semibold"><span className="counter-value" data-target="28.05">{dashboardData?.MarginLeverage || 0}</span></h2>
                        </div>
                        <div>
                          <div className="avatar-sm upcoming-icon">
                            <span className="avatar-title dash_icon bg-info-subtle rounded fs-2">
                              <i className="bx bx-trending-up font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="card mini-stats-wid">
                    <div className="card-body bg-success-subtle">
                      <div className="row pt-3">
                        <div className="col-7">
                          <div>
                            <h5 className="fw-bold">1:500</h5>
                            <p className="text-muted text-truncate mb-0">
                              Leverage
                            </p>
                          </div>
                        </div>
                        <div className="col-5">
                          <div className="flex-shrink-0 align-self-center pb-3">
                            <div className="mini-stat-icon avatar-sm rounded-circle bg-primary ms-auto">
                              <span className="avatar-title bg-success">
                                <i className="bx bx-line-chart font-size-24" />
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                                      <div>
                                          <div id="area-sparkline-chart-3" data-colors='["--bs-success"]'
                                              className="apex-charts"></div>
                                      </div>
                                  </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="col-xxl-4 col-xl-4 col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="table-responsive">
                        <CommonTable
                          hideHeader={true}
                          tableClassName="table align-middle mb-0"
                          columns={[
                            {
                              accessor: 'label',
                              className: 'd-flex align-items-center gap-3 border-end',
                              render: (row) => (
                                <>
                                  <div className="icon_tranfer">
                                    <i className={row.icon} />
                                  </div>
                                  <h5 className="font-size-14 mb-1">{row.label}</h5>
                                </>
                              )
                            },
                            {
                              accessor: 'val',
                              render: (row) => <h5 className="mb-0">{row.val}</h5>
                            }
                          ]}
                          data={[
                            { label: "Total Profit/Loss", icon: "bx bx-transfer transfer transfer_rotate", val: dashboardData?.Profit },
                            { label: "Margin", icon: "bx bx-bar-chart-alt-2 transfer", val: dashboardData?.Margin || 0 },
                            { label: "Free Margin", icon: "bx bx-bar-chart-square transfer", val: dashboardData?.MarginFree || 0 },
                            { label: "Equity", icon: "fa-solid fa-scale-balanced transfer_scale", val: dashboardData?.Equity || 0 },
                            { label: "Total Deposit", icon: "bx bx-download transfer", val: "-" },
                            { label: "Total Withdrawal", icon: "bx bx-download transfer", val: "-" }
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-8 col-xl-8 col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      {/* <h4 className="card-title mb-4">Profit/Loss</h4> */}
                      {/* <canvas
                        id="bar"
                        data-colors='["--bs-success-rgb, 0.8", "--bs-success"]'
                        height={300}
                      /> */}
                      <ProfitLossChart />
                    </div>
                  </div>

                </div>
                <div className="col-xxl-8 col-xl-8 col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title mb-4">Top 5 Traders</h4>
                      <div className="table-responsive dash_projects">
                        <CommonTable
                          tableClassName="table ib_dash_table table-nowrap table-hover mb-0"
                          columns={[
                            // { header: "#", accessor: "id" },
                            { header: "Projects", accessor: "project" },
                            { header: "Start Date", accessor: "startDate" },
                            { header: "Deadline", accessor: "deadline" },
                            { header: "Budget", accessor: "budget" }
                          ]}
                          data={[
                            { project: "crm admin UI", startDate: "2 Sep, 2019", deadline: "20 Oct, 2019", budget: "$506" },
                            { project: "crm admin Logo", startDate: "1 Sep, 2019", deadline: "2 Sep, 2019", budget: "$94" },
                            { project: "Redesign - Landing page", startDate: "21 Sep, 2019", deadline: "29 Sep, 2019", budget: "$156" },
                            { project: "App Landing UI", startDate: "29 Sep, 2019", deadline: "04 Oct, 2019", budget: "$122" },
                            { project: "Blog Template", startDate: "05 Oct, 2019", deadline: "16 Oct, 2019", budget: "$164" },
                            { project: "Redesign - Multipurpose Landing", startDate: "17 Oct, 2019", deadline: "05 Nov, 2019", budget: "$192" },
                            { project: "Logo Branding", startDate: "04 Nov, 2019", deadline: "05 Nov, 2019", budget: "$94" }
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-4 col-xl-4 col-lg-12">
                  <div className="card top-countries-card">
                    <div className="card-body">
                      <div className="p-0">
                        <h6 className="card-title fs-13 mb-2">
                          Top 5 Most Traded Symbols
                        </h6>
                      </div>
                      <div className="list-group border">
                        <div className="d-flex justify-content-between align-items-center p-3 border-top-0">
                          <div className="avatar-sm-trad">
                            <div className="avatar-title bg-primary-subtle rounded-circle text-primary font-size-20">
                              1
                            </div>
                          </div>
                          <p className="text-primary fw-bold mb-0">N/A</p>
                          <h4 className="mb-0">0.00</h4>
                        </div>
                        <div className="list-group-item d-flex justify-content-between align-items-center p-3">
                          <div className="avatar-sm-trad">
                            <div className="avatar-title bg-success-subtle rounded-circle text-success font-size-20">
                              2
                            </div>
                          </div>
                          <p className="text-success fw-bold mb-0">N/A</p>
                          <h4 className="mb-0">0.00</h4>
                        </div>
                        <div className="list-group-item d-flex justify-content-between align-items-center p-3">
                          <div className="avatar-sm-trad">
                            <div className="avatar-title bg-warning-subtle rounded-circle text-warning font-size-20">
                              3
                            </div>
                          </div>
                          <p className="text-warning fw-bold mb-0">N/A</p>
                          <h4 className="mb-0">0.00</h4>
                        </div>
                        <div className="list-group-item d-flex justify-content-between align-items-center p-3">
                          <div className="avatar-sm-trad">
                            <div className="avatar-title bg-info-subtle rounded-circle text-info font-size-20">
                              4
                            </div>
                          </div>
                          <p className="text-info fw-bold mb-0">N/A</p>
                          <h4 className="mb-0">0.00</h4>
                        </div>
                        <div className="list-group-item d-flex justify-content-between align-items-center p-3">
                          <div className="avatar-sm-trad">
                            <div className="avatar-title bg-danger-subtle rounded-circle text-danger font-size-20">
                              5
                            </div>
                          </div>
                          <p className="text-danger fw-bold mb-0">N/A</p>
                          <h4 className="mb-0">0.00</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title mb-4">Recent Traders</h4>
                      <div className="table-responsive">
                        <table
                          className="table ib_dash_table align-middle table-nowrap text-center table-hover dt-responsive nowrap w-100"
                          id="userList-table"
                        >
                          <thead className="table-light">
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Name</th>
                              <th scope="col">Email</th>
                              <th scope="col">Tags</th>
                              <th scope="col">Projects</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>xyz</td>
                              <td>535353</td>
                              <td>21</td>
                              <td>abc</td>
                              <td>
                                <i className="fa-solid fa-eye" />
                              </td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>xyz</td>
                              <td>636363</td>
                              <td>15</td>
                              <td>abc</td>
                              <td>
                                <i className="fa-solid fa-eye" />
                              </td>
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>xyz</td>
                              <td>434343</td>
                              <td>10</td>
                              <td>abc</td>
                              <td>
                                <i className="fa-solid fa-eye" />
                              </td>
                            </tr>
                            <tr>
                              <td>4</td>
                              <td>xyz</td>
                              <td>333353</td>
                              <td>11</td>
                              <td>abc</td>
                              <td>
                                <i className="fa-solid fa-eye" />
                              </td>
                            </tr>
                            <tr>
                              <td>5</td>
                              <td>xyz</td>
                              <td>123363</td>
                              <td>14</td>
                              <td>abc</td>
                              <td>
                                <i className="fa-solid fa-eye" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          {/* End Page-content */}
          <Footer />
        </div>
      </div>
    </>
  );
}
